import React, { useState } from "react";
import "../../styles/Listing.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import ABResidentialPurchase from "../../components/Checklists/Alberta/ABResidentialPurchase.js";
import ABPreConPurchase from "../../components/Checklists/Alberta/ABPreConPurchase.js";
import ABAgriPurchase from "../../components/Checklists/Alberta/ABAgriPurchase.js";
export default function ABPurchase() {
  const [PurchaseType, setPurchaseType] = useState("");

  let PurchaseTemplate = "";
  if (PurchaseType === "Residential") {
    PurchaseTemplate = <ABResidentialPurchase />;
  } else if (PurchaseType === "PreCon") {
    PurchaseTemplate = <ABPreConPurchase />;
  } else if (PurchaseType === "AgriPurchase") {
    PurchaseTemplate = <ABAgriPurchase />;
  } else {
    PurchaseTemplate = "";
  }

  const theme = createTheme({
    palette: {
      primary: {
        main: "#506CAA",
        dark: "#506CAA",
      },
      text: {
        primary: "#31303F",
        secondary: "#506CAA",
      },
    },
  });

  const setCheckList = (e) => {
    setPurchaseType(e.target.value);
  };

  return (
    <div className="checklists flex flex-col items-center justify-center">
      <div className="flex flex-col w-full pl-4 ">
        <div className="flex flex-col items-left pb-2">
          <ThemeProvider theme={theme}>
            <FormControl sx={{ mt: 1, minWidth: 325, maxWidth: 110 }}>
              <InputLabel size="small" className="select-default-label">
                Purchase Type
              </InputLabel>
              <Select
                value={PurchaseType}
                name="Purchase Type"
                label="Purchase Type"
                onChange={setCheckList}
                size="small"
                sx={{ borderRadius: 20 }}
              >
                <MenuItem key={Math.random()} value="Residential">
                  Residential
                </MenuItem>
                <MenuItem key={Math.random()} value="PreCon">
                  Pre-Construction
                </MenuItem>
                <MenuItem key={Math.random()} value="AgriPurchase">
                  Agricultural
                </MenuItem>
              </Select>
            </FormControl>
          </ThemeProvider>
        </div>
      </div>
      {PurchaseTemplate}
    </div>
  );
}
